"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.validateCommand = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _models = require("@izzistock/models");

var _Button = _interopRequireDefault(require("../Button"));

var _ProductList = _interopRequireDefault(require("../ProductList"));

var _Text = _interopRequireDefault(require("../Text"));

var _BarCodeScanner = _interopRequireDefault(require("../BarCodeScanner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var Style = _reactNative.StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    width: '100%',
    flexDirection: 'column'
  },
  scannerContainer: {
    height: '20%',
    marginBottom: 10
  },
  listProductContainer: {
    flex: 1
  },
  actionContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

var validateCommand = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var command, message, isConfirmed;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            command = _ref.command;
            message = "Etes vous sur de valider cette commande ? \n ".concat(command.getQtyReceived(), " produits re\xE7u sur ").concat(command.getQty());
            _context.next = 4;
            return confirm({
              title: 'Confimation de commande',
              msg: message
            });

          case 4:
            isConfirmed = _context.sent;

            if (isConfirmed) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", false);

          case 7:
            _context.next = 9;
            return _models.Command.validateReception({
              command: command
            });

          case 9:
            return _context.abrupt("return", true);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateCommand(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.validateCommand = validateCommand;

var _default = function _default(_ref3) {
  var command = _ref3.command,
      _ref3$onCommandChange = _ref3.onCommandChange,
      onCommandChange = _ref3$onCommandChange === void 0 ? function () {} : _ref3$onCommandChange,
      allProducts = _ref3.products,
      barCodeActions = _ref3.barCodeActions,
      _ref3$barCodeDisplay = _ref3.barCodeDisplay,
      barCodeDisplay = _ref3$barCodeDisplay === void 0 ? true : _ref3$barCodeDisplay;
  var products = command.getProductsExpanded(allProducts.data);

  var addProductItem = function addProductItem(_ref4) {
    var productId = _ref4.productId,
        _ref4$add = _ref4.add,
        add = _ref4$add === void 0 ? 1 : _ref4$add;
    onCommandChange(command.clone(function (cmd) {
      cmd.setData({
        products: command.products.map(function (product) {
          var qtyReceived = product.qtyReceived || 0;
          return _objectSpread(_objectSpread({}, product), {}, {
            qtyReceived: Math.max(product.id === productId ? qtyReceived + add : qtyReceived, 0)
          });
        })
      });
    }));
  };

  var onBarCodeScanned = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(code) {
      var product;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              product = products.find(function (product) {
                return product.code === code;
              });

              if (product) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", false);

            case 3:
              addProductItem({
                productId: product.id
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onBarCodeScanned(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: Style.container
  }, _reactNative.Platform.OS !== "web" && barCodeDisplay && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: Style.scannerContainer
  }, /*#__PURE__*/_react["default"].createElement(_BarCodeScanner["default"], {
    onScan: onBarCodeScanned,
    actions: barCodeActions
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.ScrollView, {
    style: Style.listProductContainer
  }, /*#__PURE__*/_react["default"].createElement(_ProductList["default"], {
    products: products,
    renderAction: function renderAction(product) {
      return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
        style: Style.actionContainer
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        width: 40,
        title: "-",
        onPress: function onPress(e) {
          addProductItem({
            productId: product.id,
            add: -1
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        style: {
          marginLeft: 10,
          marginRight: 10
        }
      }, product.payload.qtyReceived, " / ", product.payload.qty), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        width: 40,
        title: "+",
        onPress: function onPress(e) {
          addProductItem({
            productId: product.id
          });
        }
      }));
    }
  })));
};

exports["default"] = _default;

var confirm = function confirm(_ref6) {
  var title = _ref6.title,
      msg = _ref6.msg;
  return new Promise(function (resolve) {
    if (_reactNative.Platform.OS === "web") {
      if (window.confirm(msg)) {
        resolve(true);
      } else {
        resolve(false);
      }

      return;
    }

    _reactNative.Alert.alert(title, msg, [{
      text: "Annuler",
      onPress: function onPress() {
        return resolve(false);
      },
      style: "cancel"
    }, {
      text: "OK",
      onPress: function onPress() {
        return resolve(true);
      }
    }], {
      cancelable: false
    });
  });
};